module.exports = "/_next/static/media/573268a41b8ccca3268d5c1c484099c2.svg";